import type { NotificationType } from '@app/shared';
import i18n from '@/shared/i18n';

/** Bypasses react-i18next's namespace-narrowed `t` overloads for a runtime-computed value (same
 *  rationale as `translateOrderStatus`) — reads the shared `i18n` singleton directly via an
 *  exhaustive switch, so every branch's key stays a checked literal. */
export function translateNotificationType(type: NotificationType): string {
  switch (type) {
    case 'JOIN_REQUEST_CREATED':
      return i18n.t('client:notificationPreferences.typeJOIN_REQUEST_CREATED');
    case 'ORDER_STATUS_CHANGED':
      return i18n.t('client:notificationPreferences.typeORDER_STATUS_CHANGED');
    case 'ORDER_LINES_ADJUSTED':
      return i18n.t('client:notificationPreferences.typeORDER_LINES_ADJUSTED');
    case 'ORDER_MESSAGE':
      return i18n.t('client:notificationPreferences.typeORDER_MESSAGE');
    case 'ORDER_CREATED':
      return i18n.t('client:notificationPreferences.typeORDER_CREATED');
    case 'MEMBER_APPROVED':
      return i18n.t('client:notificationPreferences.typeMEMBER_APPROVED');
    case 'MEMBER_REJECTED':
      return i18n.t('client:notificationPreferences.typeMEMBER_REJECTED');
    case 'MEMBER_BLOCKED':
      return i18n.t('client:notificationPreferences.typeMEMBER_BLOCKED');
    case 'MEMBER_UNBLOCKED':
      return i18n.t('client:notificationPreferences.typeMEMBER_UNBLOCKED');
    case 'CLAIM_CREATED':
      return i18n.t('client:notificationPreferences.typeCLAIM_CREATED');
    case 'CLAIM_RESOLVED':
      return i18n.t('client:notificationPreferences.typeCLAIM_RESOLVED');
    case 'STOCK_ARRIVED':
      return i18n.t('client:notificationPreferences.typeSTOCK_ARRIVED');
    case 'LOW_STOCK':
      return i18n.t('client:notificationPreferences.typeLOW_STOCK');
    case 'EXPIRING_BATCH':
      return i18n.t('client:notificationPreferences.typeEXPIRING_BATCH');
    case 'DEBT_OVERDUE':
      return i18n.t('client:notificationPreferences.typeDEBT_OVERDUE');
    case 'STOCK_VERIFY_MISMATCH':
      return i18n.t('client:notificationPreferences.typeSTOCK_VERIFY_MISMATCH');
  }
}
